import { render, staticRenderFns } from "./WorkscheduleItemCard.vue?vue&type=template&id=0b4598e8&"
import script from "./WorkscheduleItemCard.vue?vue&type=script&lang=js&"
export * from "./WorkscheduleItemCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports